import home from "../../assets/images/homepart.jpg";
import './Home.css';
import HomePart from "../../components/HomePart/HomePart";
import { NavLink } from 'react-router-dom';

function Home() {
    const services = [
        {
            title: "Business Consulting",
            description: "Strategic guidance to optimize your business operations and maximize growth potential.",
            icon: "💼"
        },
        {
            title: "Project Management",
            description: "End-to-end project delivery with proven methodologies and expert oversight.",
            icon: "📋"
        },
        {
            title: "Digital Solutions",
            description: "Modern technology solutions to streamline processes and enhance efficiency.",
            icon: "💻"
        }
    ];

    const stats = [
        { number: "50+", label: "Projects Completed" },
        { number: "25+", label: "Happy Clients" },
        { number: "5+", label: "Years Experience" },
        { number: "100%", label: "Client Satisfaction" }
    ];

    return(
        <div className="home-page">
            <HomePart/>
            
            {/* Services Preview Section */}
            <div className="services-preview">
                <div className="container">
                    <div className="section-header">
                        <h2>Our Services</h2>
                        <p>Comprehensive solutions tailored to your business needs</p>
                    </div>
                    <div className="services-grid">
                        {services.map((service, index) => (
                            <div key={index} className="service-card">
                                <div className="service-icon">{service.icon}</div>
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                            </div>
                        ))}
                    </div>
                    <div className="section-footer">
                        <NavLink to="/services" className="btn btn-outline" onClick={() => window.scrollTo(0, 0)}>
                            View All Services
                        </NavLink>
                    </div>
                </div>
            </div>

            {/* Stats Section */}
            <div className="home-stats-section">
                <div className="home-stats-container">
                    <div className="home-stats-grid">
                        {stats.map((stat, index) => (
                            <div key={index} className="home-stat-item">
                                <div className="home-stat-number">{stat.number}</div>
                                <div className="home-stat-label">{stat.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* About Preview Section */}
            <div className="home-about-preview">
                <div className="home-about-container">
                    <div className="home-about-content">
                        <div className="home-about-text">
                            <h2>Why Choose SCPO Group?</h2>
                            <p>
                                With years of experience in business consulting and project management, 
                                we've helped numerous companies achieve their goals through innovative 
                                solutions and strategic partnerships.
                            </p>
                            <ul className="home-features-list">
                                <li>✓ Proven track record of success</li>
                                <li>✓ Dedicated team of experts</li>
                                <li>✓ Customized solutions for every client</li>
                                <li>✓ 24/7 support and communication</li>
                            </ul>
                            <NavLink to="/about" className="home-btn home-btn-primary" onClick={() => window.scrollTo(0, 0)}>
                                Learn More About Us
                            </NavLink>
                        </div>
                        <div className="home-about-image">
                            <img src={home} alt="SCPO Group Team" />
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="cta-section">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Transform Your Business?</h2>
                        <p>Let's discuss how we can help you achieve your goals</p>
                        <div className="cta-buttons">
                            <NavLink to="/contact" className="btn btn-primary btn-large" onClick={() => window.scrollTo(0, 0)}>
                                Get Started Today
                            </NavLink>
                            <NavLink to="/services" className="btn btn-secondary btn-large" onClick={() => window.scrollTo(0, 0)}>
                                Explore Services
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home
